import * as amplitude from '@amplitude/analytics-browser';
import { Identify, identify } from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

import type { Workspace } from '@/entities/workspace/workspace-types';
import type { TrackEvent } from '@/shared/track/events';
import type { User } from '../../entities/user/user-types';
import type { EventOptions } from '@amplitude/analytics-browser/lib/esm/types';

export const trackAmplitudeEvent = (event: TrackEvent, eventOptions?: EventOptions) => {
  amplitude.track(event.name, event.properties, eventOptions);
};

export const initAmplitude = (user: User, workspace: Workspace) => {
  const sessionReplayTracking = sessionReplayPlugin();
  amplitude.add(sessionReplayTracking);
  amplitude.init(import.meta.env.VITE_AMPLITUDE_API_KEY as string, user.email, {
    autocapture: {
      elementInteractions: true,
    },
    defaultTracking: {
      pageViews: {
        trackOn: 'attribution',
      },
    },
  });
  amplitudeIdentifyUser(user, workspace);
};

export const amplitudeIdentifyUser = (user: User, workspace: Workspace) => {
  amplitude.setUserId(user.id);
  identify(
    new Identify()
      .set('email', user.email)
      .set('role', workspace.privilege)
      .set('plan', workspace.plan)
      .set('workspace_id', workspace.id)
      .set('workspace_name', workspace.name),
  );
};
